const defaultState = {
    session_tracker: {}
};

const getters = {
    isAgencyCentral(state) {
        return (state.session_tracker.isAgencyCentral !== undefined 
            && state.session_tracker.isAgencyCentral == 1) ? true : false;
    }
}

export default {
    namespaced: true,
    getters,
    state: defaultState,
};
